import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { AuthContext } from "../components/authProvider";
import PassEye from "../components/passEye";

export default function HomePage() {
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [state, setState] = useState(0);
  const [send, setSend] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { currentUser, role } = useContext(AuthContext);

  const loginFormRef = useRef(null);
  const resetFormRef = useRef(null);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSend("");

    try {
      const formData = new FormData(e.currentTarget);
      const email = String(formData.get("email") || "").trim();
      const password = String(formData.get("password") || "");

      await signInWithEmailAndPassword(getAuth(), email, password);
    } catch (err) {
      console.error("LOGIN ERROR:", err);
      setError("Niepoprawne dane logowania, spróbuj ponownie.");
      setLoading(false);
    }
  };

  useEffect(() => {

    if (!currentUser) return;
    if (!role) return;

    if (role === "admin") {
      navigate("/frekwencja-admin", { replace: true });
    } else {
      setError("Niepoprawne dane logowania, spróbuj ponownie.");
    }

    setLoading(false);
  }, [currentUser, role, navigate]);

  const resetPassword = async (e) => {
    e.preventDefault();
    setError("");
    setSend("");

    try {
      const formData = new FormData(e.currentTarget);
      const email = String(formData.get("email") || data?.email || "").trim();

      await sendPasswordResetEmail(auth, email);
      setSend("Wiadomość email z resetem hasła została wysłana, sprawdź swoją pocztę");
    } catch (error) {
      setError("Błąd podczas resetowania hasła, spróbuj ponownie później");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "rgb(240,240,240)",
        width: "100%",
        minHeight: "100vh",
        overflowY: "scroll",
        gap: "30px",
      }}
    >
      {state === 0 && (
        <form
          ref={loginFormRef}
          onSubmit={login}
          autoComplete="on"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "15px",
            width: "80%",
          }}
        >
          <img src="logosvg.svg" style={{ width: "150px", marginBottom: "-40px" }} />
          <h3 style={{ fontSize: "30px", color: "rgb(30,30,30)", textAlign: "center" }}>
            Witaj ponownie!
          </h3>
          <h3
            style={{
              fontSize: "14px",
              color: "rgb(30,30,30)",
              fontWeight: "lighter",
              textAlign: "center",
              marginTop: "-10px",
              marginBottom: "20px",
            }}
          >
            Nie jesteś jeszcze członkiem żadnej placówki? Skontaktuj się z nami i zapisz się już teraz!
          </h3>

          <input
            className="login"
            type="email"
            name="email"
            autoComplete="username"
            placeholder="Adres email"
            value={data.email}
            style={{
              height: "25px",
              width: "270px",
              fontWeight: "normal",
              appearance: "none",
              outline: "none",
              backgroundColor: "rgb(250,250,250)",
              padding: "6px 35px",
              color: "rgb(20,20,20)",
              backgroundImage: `url(${process.env.PUBLIC_URL + "/email.png"})`,
              backgroundSize: "17px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "8px 8.5px",
              paddingLeft: "40px",
              transition: "0.8s",
              border: "1px solid rgb(30,30,30)",
              borderRadius: "5px",
            }}
            onChange={(e) => {
              setData((prev) => ({ ...prev, email: e.target.value }));
              setError("");
            }}
          />

          <PassEye
            name="password"
            autoComplete="current-password"
            value={data.password}
            onChange={(e) => {
              setData((prev) => ({ ...prev, password: e.target.value }));
              setError("");
            }}
          />

          {error && (
            <h3
              style={{
                fontSize: "14px",
                color: "#e60000",
                fontWeight: "normal",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {error}
            </h3>
          )}

          <h3
            style={{
              fontSize: "14px",
              color: "#0045C7",
              fontWeight: "lighter",
              textAlign: "center",
              marginTop: "50px",
              marginBottom: "-10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setState(1);
              setError("");
              setSend("");
            }}
          >
            Nie pamiętasz hasła? <u>Kliknij tutaj</u>
          </h3>

          <button
            type="submit"
            style={{
              fontSize: "13px",
              color: "white",
              borderRadius: "5px",
              marginTop: "10px",
              backgroundColor: "#0045C7",
              border: "2px solid #0045C7",
              transition: "0.7s",
              fontWeight: "bold",
              padding: "10px 30px",
              width: "250px",
            }}
            disabled={loading}
          >
            {loading ? "Proszę czekać..." : "Zaloguj się"}
          </button>
        </form>
      )}

      {state === 1 && (
        <form
          ref={resetFormRef}
          onSubmit={resetPassword}
          autoComplete="on"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "15px",
            width: "80%",
          }}
        >
          <img src="logosvg.svg" style={{ width: "150px", marginBottom: "-40px" }} />
          <h3 style={{ fontSize: "30px", color: "rgb(30,30,30)", textAlign: "center" }}>
            Zresetuj hasło
          </h3>
          <h3
            style={{
              fontSize: "14px",
              color: "rgb(30,30,30)",
              fontWeight: "lighter",
              textAlign: "center",
              marginTop: "-10px",
              marginBottom: "20px",
            }}
          >
            Wpisz swój adres email, a dostaniesz na niego wiadomość z linkiem, przez który zresetujesz swoje hasło.
          </h3>

          {send && (
            <h3
              style={{
                fontSize: "14px",
                color: "#0045C7",
                fontWeight: "lighter",
                textAlign: "center",
                marginTop: "-10px",
              }}
            >
              {send}
            </h3>
          )}

          {error && (
            <h3
              style={{
                fontSize: "14px",
                color: "#e60000",
                fontWeight: "normal",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {error}
            </h3>
          )}

          <input
            className="login"
            type="email"
            name="email"
            autoComplete="username"
            placeholder="Adres email"
            value={data.email}
            style={{
              height: "25px",
              width: "270px",
              fontWeight: "normal",
              appearance: "none",
              outline: "none",
              backgroundColor: "rgb(250,250,250)",
              padding: "6px 35px",
              color: "rgb(20,20,20)",
              backgroundImage: `url(${process.env.PUBLIC_URL + "/email.png"})`,
              backgroundSize: "17px",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "8px 8.5px",
              paddingLeft: "40px",
              transition: "0.8s",
              border: "1px solid rgb(30,30,30)",
              borderRadius: "5px",
            }}
            onChange={(e) => {
              setData((prev) => ({ ...prev, email: e.target.value }));
              setError("");
            }}
          />

          <button
            type="submit"
            style={{
              fontSize: "13px",
              color: "white",
              borderRadius: "5px",
              marginTop: "10px",
              backgroundColor: "#0045C7",
              border: "2px solid #0045C7",
              transition: "0.7s",
              fontWeight: "bold",
              padding: "10px 30px",
              width: "250px",
            }}
          >
            Resetuj
          </button>

          <button
            type="button"
            style={{
              fontSize: "13px",
              color: "white",
              borderRadius: "5px",
              marginTop: "-5px",
              backgroundColor: "#0045C7",
              border: "2px solid #0045C7",
              transition: "0.7s",
              fontWeight: "bold",
              padding: "10px 30px",
              width: "250px",
            }}
            onClick={() => {
              setState(0);
              setError("");
              setSend("");
            }}
          >
            Powrót
          </button>
        </form>
      )}
    </div>
  );
}